import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { INDRAUserProfile, INDRATAPUserProfile } from '@ibe.models/user.indra.model.lib';

@Injectable({
	providedIn: 'root'
})
export class LoginModalService {
	private dataUser: INDRATAPUserProfile;
	private currentDataUser = new BehaviorSubject(this.dataUser);

	constructor() {
	}

	sendDataCustomer(dataCustomer: INDRATAPUserProfile) {
		this.dataUser = dataCustomer;
		this.currentDataUser.next(this.dataUser);
	}

	getObject(): Observable<INDRATAPUserProfile> {
		return this.currentDataUser.asObservable();
	}

}
